import React from 'react'

import { Pencil } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'

import { Button, IconWrapper } from './styles'

export const WriteReviewButton: React.FC<{
  variant: 'filled' | 'black-on-white-no-border'
  disabled?: boolean
  onClick: () => void
}> = ({ variant, disabled, onClick }) => {
  const {
    magnolia: {
      reviewsPage: { writeReviewCta },
    },
  } = useTranslation()

  return (
    <Button {...{ disabled, onClick, variant }} allCaps={false}>
      <IconWrapper>
        <Pencil aria-hidden='true' />
      </IconWrapper>
      {writeReviewCta}
    </Button>
  )
}
